<template>
  <div class="wrap">
    <div class="loginWrap">
      <div class="logo clr">
        <img
          class="fl"
          src="https://static.cizhuangyuan.com/static/sysimg/ai/images/login_logo.png"
          alt="图片"
        >
        <!-- <div class="text fl">
					<h2>智能英语</h2>
					<p>Intelligent English</p>
				</div> -->
      </div>
      <div class="loginCon" :style="{'bottom':(isapp && isfocused)?'0px':'3rem'}">
        <div class="switch"></div>
        <div class="title">
          <span>密码登录</span>
        </div>
        <el-form
          size="mini"
          :model="ruleForm"
          ref="ruleForm"
          label-width="0x"
        >
          <el-form-item
            class="input"
            :rules="[{required: true,message: '请输入您的账号',trigger: ['blur', 'change']}]"
            prop="username"
          >
            <el-input
              placeholder="用户名/卡号"
              type="text"
              @keyup.enter.native="login"
              v-model="ruleForm.username"
              autocomplete="off"
              @blur="input_blue"
              @focus="input_focus"
              ref="usernametag"
            ></el-input>
          </el-form-item>
          <el-form-item
            class="input"
            :rules="[{required: true,message: '请输入登陆密码',trigger: ['blur', 'change']}]"
            prop="password"
          >
            <el-input
              placeholder="密码"
              type="password"
              @keyup.enter.native="login"
              v-model="ruleForm.password"
              autocomplete="off"
              @blur="input_blue"
              @focus="input_focus"
            ></el-input>
          </el-form-item>
          <el-form-item
            v-if="ruleForm.hidecode == false"
            class="input on"
            :rules="[{required: true,message: '请输入验证码',trigger: ['blur', 'change']}]"
            prop="checkcode"
          >
            <el-input
              placeholder="验证码"
              type="text"
              @keyup.enter.native="login"
              v-model="ruleForm.checkcode"
              autocomplete="off"
            ></el-input>
            <div class="yzm">
              <img
                @click="refashimg"
                title="点击更换验证码"
                :src="imgpath"
              >
            </div>
          </el-form-item>
        </el-form>
        <div
          class="button"
          @click="login"
        >登录</div>
      </div>
      <div class="loginlleftImg"></div>
      <div class="loginlrightImg"></div>
    </div>
    <div class="loginBot">copyright © {{(new Date()).getFullYear()}} 安徽云朵教育科技有限公司 皖ICP备19018834号</div>
  </div>
</template>
<script>
import { login } from "../../api/base";
export default {
  data() {
    return {
      imgpath: ``,
      ruleForm: {
        username: "",
        password: "",
        checkcode: "",
        ip: "",
        hidecode: false
      },
      isapp:false,
      isfocused :false,
    };
  },
  created() {
    let url = window.location.href;

    if(url.startsWith('http://')){ 
      let newurl = url.replace('http','https'); 
      console.log(newurl); 
      window.location.href = newurl;
    }

    this.ip = Math.random();
    this.imgpath =
      this.$url + `api/login/getimg?ip=${this.ip}&rd=${Math.random()}`;
    if (this.utils.sessionGet("userinfo")) {
      this.$router.push({ path: "/index" });
      return false;
      // this.utils.storageRemove("userinfo");
    }

    let code = this.$route.query.hidecode;

    let storeCode = this.utils.sessionGet("hidecode");
    console.log("storeCode:" + storeCode);

    const isMobile = /uni-app/.test(navigator.userAgent);
    this.isapp = isMobile;
    if (code || isMobile) {
      this.ruleForm.hidecode = true;
      this.utils.sessionSet("hidecode", code);
    } else {
      if (storeCode) {
        this.ruleForm.hidecode = true;
        this.utils.sessionSet("hidecode", code);
        console.log("hidecode:" + this.ruleForm.hidecode);
      }
    }
    
    if (this.utils.sessionGet("userinfo")) {
      this.$router.push({ path: "/index" });
      return false;
      // this.utils.storageRemove("userinfo");
    }

    this.utils.sessionSet("chaoshi", 0);
    this.utils.storageClear();
  },
  methods: {
    login() {
      var that = this;
      that.$refs["ruleForm"].validate(valid => {
        if (valid) {
          login({
            username: that.ruleForm.username,
            password: that.ruleForm.password,
            checkcode: that.ruleForm.checkcode,
            ip: that.ip,
            hidecode: that.hidecode
          }).then(res => {
            res.pwd = "";
            that.utils.storageSet("userinfo", res);
            that.utils.storageSet("usermessage", res);
            that.utils.sessionSet("userinfo", res);
            that.$router.push({ path: "/index" });
            
          });
        } else {
          return false;
        }
      });
    },
    refashimg() {
      this.imgpath =
        this.$url + `api/login/getimg?ip=${this.ip}&rd=${Math.random()}`;
    },
    username_blue(){
      const target = this.$refs.username_blue; // 获取目标元素
      if (target) {
        target.scrollIntoView({ behavior: 'smooth' }); // 平滑滚动到目标位置
      }
    },
    input_focus(){
      this.isfocused =true;
    },
    input_blue(){
      this.isfocused =false;
    }

  },
  mounted() {},
  components: {}
};
</script>
<style scoped>
</style>